import React from "react";
import canaanProduct1Image from "../../../../assets/Canaan/Canaan-Product1.png";

import "./box1avalon.css"; // Assuming you import your CSS file for component styles

const Box1Avalon = () => {
  return (
    <div className="mine-thunder-canaan-avalon-container">
      <div className="mine-thunder-canaan-avalon-left">
        <div className="mine-thunder-canaan-avalon-title">Avalon Made</div>
        <div className="mine-thunder-canaan-avalon-big-title">
          Avalon Miner A1326-112T 3500W
        </div>
        <div className="mine-thunder-canaan-avalon-text">
          The Avalon Miner A1326-112T 3500W represents a pinnacle in mining
          hardware, delivering impressive mining power with its exceptional hash
          rate of 112 terahashes per second. Its efficiency, drawing only 3500W
          of power, showcases a remarkable balance between energy consumption
          and high-performance mining. This miner's cutting-edge technology
          ensures optimal mining output while maintaining a lower energy
          footprint compared to many counterparts in the market, making it a
          preferred choice for those seeking both power and efficiency in
          cryptocurrency mining setups.
          <br></br>
          <br></br>
          With its robust build and reliable performance, the Avalon Miner
          A1326-112T 3500W offers not just power and efficiency but also a
          user-friendly experience. Its intuitive interface and ease of setup
          make it accessible even to those new to the mining world. This miner's
          reputation for stability and consistent performance adds to its
          allure, making it a sought-after solution for both seasoned miners and
          newcomers looking to delve into the realm of cryptocurrency mining
          with confidence.
        </div>
        <a href="/avalon-shop" className="mine-thunder-canaan-avalon-shop-now">
          Shop Now
        </a>
      </div>
      <div className="mine-thunder-canaan-avalon-right">
        <img
          src={canaanProduct1Image}
          alt="Canaan Product 1"
          className="mine-thunder-canaan-avalon-image"
        />
      </div>
    </div>
  );
};

export default Box1Avalon;
